import debug from "debug";
import { onAvailable } from "@core/plugins/lib/selectors";

const ELEMENT_SELECTOR = "[data-collapsible-escape]";
const log = debug("collapsible-escape");

onAvailable.ready(ELEMENT_SELECTOR, (element) => {
	log('onAvailable', element);
	element.addEventListener("click", () => {
		element.dispatchEvent(new CustomEvent("escape", { bubbles: true}));
	});
});



// WEBPACK FOOTER //
// ./project/client/src/core/modules/collapsible-escape/collapsible-escape.js